export default __webpack_public_path__ + "static/media/tarjeta_corporativo.b9ea363a.png";